export function formatPlays(plays: number): string {
  if (plays >= 100000000) {
    return `${(plays / 100000000).toFixed(1)}亿`;
  }
  if (plays >= 10000) {
    return `${(plays / 10000).toFixed(1)}万`;
  }
  return `${plays}`;
}

export function typeBadgeClass(type: string): string {
  if (type === "movie") return "bg-primary-500/90 text-background-50";
  if (type === "tv") return "bg-accent-500/90 text-background-50";
  return "bg-secondary-500/90 text-background-50";
}